<div class="resource-items"></div>
